export const GET_PURE_COURSE_SUCCESS = 'GET_PURE_COURSE_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
